/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import toastr from 'toastr';
import Logout from '../../../shared/auth/Logout';
import { API_URL, RESEARCH_AND_DEVELOPMENT } from '../../../../../utils/config';
import ResearchAndDevelopmentSideBar from '../../../../layouts/research-and-development/ResearchAndDevelopmentSideBar';
import LearningPortal from '../../../shared/learning-portal/LearningPortal';
import { SUPER_ADMIN } from '../../../../../utils/departments/helpers';

class RDLearningPortal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      //   role: '',
    };
  }

  componentDidMount() {
    this.getUserDetails();
    this.fetchLoggedOnUser();
  }

  getUserDetails() {
    axios({
      method: 'get',
      url: `${API_URL}/employee/loggedOnEmployee`,
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
    }).then((res) => {
      if (res.data) {
        this.setState({
          firstName: res.data.firstName,
        });
      }
    });
  }

  fetchLoggedOnUser() {
    axios({
      method: 'get',
      url: `${API_URL}/employeeReg/logged`,
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
      json: true,
    })
      .then((response) => {
        this.setState({
          //   role: response.data.role_id,
        });

        if (response.data.id) {
          if (
            response.data.department_id !== `${RESEARCH_AND_DEVELOPMENT}` &&
            response.data.department_id !== `${SUPER_ADMIN}`
          ) {
            this.props.history.push('/staff/login');
            toastr.info('You are not allowed to view this page');
          }
        }
      })
      .catch((err) => {});
  }

  render() {
    const { firstName, role } = this.state;

    return (
      <div className="s-layout">
        <main className="s-layout__content col-lg-10 p-0">
          <div className="d-flex col-lg-12 p-2 top-header">
            <div className="mt-3 d-flex col-lg-12 p-0">
              <Link className="s-sidebar__trigger" to="#">
                <i className="fa fa-bars mr-3" />
              </Link>

              <ResearchAndDevelopmentSideBar />

              <h3 className="col-lg-6 overview-part">
                Learning Portal<span className="sr-only">(current)</span>
              </h3>

              <div className="d-flex profile-mail">
                <span className="mt-2 mr-4">{firstName}</span>
                <Logout />
              </div>
            </div>
          </div>

          <div className="all-sides col-lg-12 col-md-12 col-sm-12">
            <div className="container">
              <div className="row mt-5">
                <div className="col-lg-12 col-md-12 col-sm-12 mb-3 mt-4">
                  <LearningPortal department="RESEARCH_AND_DEVELOPMENT" />
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

export default RDLearningPortal;
